import { useQuery } from '@tanstack/react-query';
import { getListDockerVersionQuery } from '../apis';

const useGetRepositoryVersions = ({
  repository,
  pageIndex,
  pageSize,
  searchTerm,
}) => {
  const query = useQuery({
    queryKey: [
      'repositories-versions',
      repository,
      pageIndex,
      pageSize,
      searchTerm,
    ],
    enabled: !!repository,
    queryFn: () =>
      getListDockerVersionQuery({
        repository,
        pageIndex,
        pageSize,
        searchTerm,
      }),
    staleTime: 0,
  });

  return query;
};

export default useGetRepositoryVersions;
